import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-youth-red-cross', templateUrl: './youth-red-cross.component.html', styleUrls: ['./youth-red-cross.component.scss'] })
export class YouthRedCrossComponent implements OnInit {

  yrcImages = [
    '/assets/img/quick-links/yrc/1 (1).png',
    '/assets/img/quick-links/yrc/1 (1).jpg',
    '/assets/img/quick-links/yrc/1 (2).jpg',
    '/assets/img/quick-links/yrc/1 (3).jpg',
    '/assets/img/quick-links/yrc/1 (4).jpg',
    '/assets/img/quick-links/yrc/1 (5).jpg',
    '/assets/img/quick-links/yrc/1 (6).jpg',
    '/assets/img/quick-links/yrc/1 (7).jpg',
    '/assets/img/quick-links/yrc/1 (8).jpg',
    '/assets/img/quick-links/yrc/1 (9).jpg',
    '/assets/img/quick-links/yrc/1 (10).jpg',
    '/assets/img/quick-links/yrc/1 (11).jpg',
    '/assets/img/quick-links/yrc/1 (12).jpg',
    '/assets/img/quick-links/yrc/1 (13).jpg',
    '/assets/img/quick-links/yrc/1 (14).jpg',
    '/assets/img/quick-links/yrc/1 (15).jpg',
    '/assets/img/quick-links/yrc/1 (16).jpg',
    '/assets/img/quick-links/yrc/1 (17).jpg',
    '/assets/img/quick-links/yrc/1 (18).jpg',
    '/assets/img/quick-links/yrc/1 (19).jpg',
    '/assets/img/quick-links/yrc/1 (20).jpg',
    '/assets/img/quick-links/yrc/1 (21).jpg',
    '/assets/img/quick-links/yrc/1 (22).jpg',
    '/assets/img/quick-links/yrc/1 (23).jpg',
    '/assets/img/quick-links/yrc/1 (24).jpg',
    '/assets/img/quick-links/yrc/1 (25).jpg',
    '/assets/img/quick-links/yrc/1 (26).jpg',
    '/assets/img/quick-links/yrc/1 (27).jpg',
    '/assets/img/quick-links/yrc/1 (28).jpg',
    '/assets/img/quick-links/yrc/1 (29).jpg',
    '/assets/img/quick-links/yrc/1 (30).jpg',
    '/assets/img/quick-links/yrc/1 (31).jpg',
    '/assets/img/quick-links/yrc/1 (32).jpg',
    '/assets/img/quick-links/yrc/1 (33).jpg',
    '/assets/img/quick-links/yrc/1 (34).jpg',
    '/assets/img/quick-links/yrc/1 (35).jpg',
    '/assets/img/quick-links/yrc/1 (36).jpg',
    '/assets/img/quick-links/yrc/1 (37).jpg',
    '/assets/img/quick-links/yrc/1 (38).jpg',
    '/assets/img/quick-links/yrc/1 (39).jpg',
    '/assets/img/quick-links/yrc/1 (40).jpg',
    '/assets/img/quick-links/yrc/1 (41).jpg',
    '/assets/img/quick-links/yrc/1 (42).jpg',
    '/assets/img/quick-links/yrc/1 (43).jpg',
    '/assets/img/quick-links/yrc/1 (44).jpg',
    '/assets/img/quick-links/yrc/1 (45).jpg',
    '/assets/img/quick-links/yrc/1 (46).jpg',
    '/assets/img/quick-links/yrc/1 (47).jpg',
    '/assets/img/quick-links/yrc/1 (48).jpg',
    '/assets/img/quick-links/yrc/1 (49).jpg',
    '/assets/img/quick-links/yrc/1 (50).jpg',
  ];

  constructor() { } ngOnInit(): void { } }
